import React from 'react';
import cs from 'classnames';

import accountCSS from '../../index.css';

class SiderBarController extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      currentIndex: 0,
    };
    this.itemNav = this.itemNav.bind(this);
    this.clickHandle = this.clickHandle.bind(this);
    this.judgeCurrentIndex = this.judgeCurrentIndex.bind(this);
    this.Routeconfig = props.config.route
  }

  componentWillMount() {
    this.judgeCurrentIndex();
  }

  componentWillReceiveProps() {
    this.judgeCurrentIndex();
  }

  render() {
    return (
      <ul className={cs(this.props.className)}>
        {
          React.Children.map(this.props.children, (element, index) => (
            <li
              className={cs(element.props.className, accountCSS[`${this.itemNav(index)}`])}
              onClick={() => {this.clickHandle(element, index);}}
            >{element.props.title}</li>
          ))
        }
      </ul>
    );
  }

  itemNav(index) {
    return index === this.state.currentIndex ? 'active' : '';
  }

  clickHandle(element, index) {
    if (this.props.disable === 'true') {
      return null;
    }
    this.setState({currentIndex: index});
    return element.props.fn();
  }

  // GET CURRENT URL AND SET THE NAVBAR TO CURRENT ROUTE
  judgeCurrentIndex() {
    const { config } = this.props;
    const hrefArr = location.pathname.split('/');
    const hrefArrLen = hrefArr.length;
    if (hrefArrLen) {
      if (hrefArr[hrefArrLen - 1] === config.path) {
        return this.setState({
          currentIndex: parseInt(this.Routeconfig[config.index]),
        });
      }
      return this.setState({
        currentIndex: parseInt(this.Routeconfig[hrefArr[hrefArrLen - 1]]),
      });
    }
    return null;
  }
}

export default SiderBarController;



// WEBPACK FOOTER //
// ./src/components/pages/MyAccount/share/SiderBar/index.js